// Utilitaire spécifique aux connecteurs netsoins

export function checkUrl(value){
  try {
    const url = new URL(value);
    if (url.protocol.toLowerCase() === 'https:' || url.protocol.toLowerCase() === 'http:') 
      return true;
    else return false;
  } catch (error) {
    return false;
  }
}

export function makeUrl(value){
  const url = new URL(value);
  url.protocol = 'https:';
  url.pathname = '/webservice.php/teranga';
  return url.href;
}

export function getDomain(value){
  const url = new URL(value);
  url.protocol = 'https:';
  url.pathname = '';
  return url.href
}


// Transforme le sdonnées de l'API en un objet pour la page
export function getConfNetSoins(conf, data, model ){
  const srv = data?.eec_data?.refs?.find(m=>m.type==='SERVICE');
  const mserv = model.refs.find(m=>m.type === 'SERVICE');
  conf.enable= data?.eec_is_enable || false;
  conf.apikey= data?.eec_data?.api_key || model.api_key;
  conf.apiurl= data?.eec_data?.api_url || model.api_url;
  conf.enable_push_activity= data?.eec_data?.enable_push_activity; // No need to replace by model value, undefined is a valid value
  conf.enable_push_patgames= data?.eec_data?.enable_push_patgames;
  conf.metiers= data?.eec_data?.refs?.find(m=> m.type === 'JOB')?.mappings || model.refs.find(m=> m.type === 'JOB').mappings;
  conf.service= {
      source: srv?.source || mserv.source,
      default: srv?.default_id || mserv.default_id
    };
  conf.jobsfilter= data?.eec_data?.filter?.find(f=>f.type === 'STAFF')?.include || model.filter.find(f=>f.type === 'STAFF').include;
  conf.datainitial= data?.eec_data
  conf.ctx = data?.eec_id
  conf.saved = !!(data?.eec_data)
  return conf;
}

export function getCongNetsoinsPush( conf, data, model ) {

  const push = data?.eec_data?.feature?.push;
  conf.push = push || model.feature.push;
  conf.enablepush = data?.eec_is_enable || false;
  conf.savedpush = !!(data?.eec_data);
  return conf;
}


export function setDataNetsoinsFromConf(conf, model){
  // clone du model sinon même référence
  const data = {...model};
  const srv = data.refs.find(m=>m.type==='SERVICE')
  srv.source = conf.service.source;
  srv.default_id = conf.service.default;

  data.refs.find(m=> m.type === 'JOB').mappings = conf.metiers;
  data.filter.find(f=>f.type === 'STAFF').include = conf.jobsfilter;
  data.api_key = conf.apikey;
  data.ext_uri = conf.apikey;
  data.enable_push_activity = conf.enable_push_activity;
  data.enable_push_patgames = conf.enable_push_patgames;

  if (checkUrl(conf.apiurl))
    data.api_url = makeUrl(conf.apiurl);

  return data;
}

export function setDataNetsoinsPushFromConf(conf, model){
  const data = {...model};

  data.feature.push = conf.push;

  data.api_key = conf.apikey;
  data.ext_uri = conf.apikey;
  
  if (checkUrl(conf.apiurl))
    data.api_url = makeUrl(conf.apiurl);

  return data;
}